// components/Common/RichTextEditor.js

import richEditorStyles from "./RichEditor.module.css";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const RichTextEditor = ({
  label,
  value,
  onChange,
  error,
  validate, // ✅ added
}) => {
  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline"],
      [{ color: [] }],
      [{ list: "ordered" }, { list: "bullet" }],
      ["clean"],
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "color",
    "list",
    "bullet",
  ];

  // ✅ validation logic
  const isEmpty = !value || value === "<p><br></p>";

  const showError =
    validate?.required?.value && isEmpty;

  const errorMessage =
    showError ? validate.required.errorMessage : error;

  return (
    <div className="mb-3">
      {label && (
        <label className="form-label fw-semibold mb-2">{label}</label>
      )}

      <div
        className={`${richEditorStyles.wrapper} ${
          showError ? "border border-danger" : ""
        }`}
      >
        <ReactQuill
          theme="snow"
          value={value || ""}
          onChange={(content) => {
            // normalize empty value
            if (content === "<p><br></p>") {
              onChange("");
            } else {
              onChange(content);
            }
          }}
          modules={modules}
          formats={formats}
          placeholder="Start typing..."
        />
      </div>

      {(showError || error) && (
        <div className="text-danger mt-1" style={{ fontSize: "12px" }}>
          {errorMessage}
        </div>
      )}
    </div>
  );
};

export default RichTextEditor;